import { twJoin } from 'tailwind-merge'

import Button from '@components/designSystem/Button'

export interface RadioEntry<T extends string = string> {
  label: string
  value: T
  disabled?: boolean
}

interface ButtonGroupProps<T extends readonly RadioEntry[]> {
  entries: T
  onChange: (value: T[number]['value']) => void
  selectedValue: T[number]['value']
  className?: string
}

function ButtonGroup<T extends readonly RadioEntry[]>({
  entries,
  onChange,
  selectedValue,
  className,
}: ButtonGroupProps<T>) {
  return (
    <div className={twJoin('flex flex-row gap-2', className)} role="radiogroup">
      {entries.map(({ label, value, disabled }) => {
        const isSelected = selectedValue === value
        return (
          <Button
            key={value}
            onClick={() => !disabled && onChange(value)}
            variant={isSelected ? 'dark' : 'outline'}
            isDisabled={disabled}
          >
            {label}
          </Button>
        )
      })}
    </div>
  )
}

export default ButtonGroup